import { render, staticRenderFns } from "./orderLoanStatusLoanCountInstallment.vue?vue&type=template&id=4b94fafd&scoped=true"
import script from "./orderLoanStatusLoanCountInstallment.vue?vue&type=script&lang=js"
export * from "./orderLoanStatusLoanCountInstallment.vue?vue&type=script&lang=js"
import style0 from "./orderLoanStatusLoanCountInstallment.vue?vue&type=style&index=0&id=4b94fafd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b94fafd",
  null
  
)

export default component.exports